<template>
  <div>
    <b-row>
      <b-col xl="10">
        <b-card footer-tag="footer">
          <div slot="header">
            <b-button-group class="float-right">
              <b-button @click="maakKopieFactuur()">
                <i class="fa fa-copy" /> Kopieer naar nieuwe concept factuur
              </b-button>

              <b-button
                :disabled="!$props.id"
                variant="primary"
                @click="showSendModal()"
              >
                <i class="fa fa-send" /> Verstuur test
              </b-button>
            </b-button-group>
            <strong>{{
              factuur.Factuurnummer
                ? "Factuur " + factuur.Factuurnummer
                : "Concept factuur"
            }}</strong>
            <br>
            <small v-if="$props.id">{{ $props.id }}</small>
            <small v-else>nog niet opgeslagen</small>
          </div>
          <b-row>
            <b-col cols="8">
              <b-row>
                <b-col>
                  <b-form-group label="Relatie">
                    <b-select
                      v-if="relaties"
                      v-model="factuur.Relatie"
                      :options="
                        relaties.map(function (relatie) {
                          return { text: relatie.Naam, value: relatie };
                        })
                      "
                      @input="checkFacturatieAdres($event)"
                    >
                      <template #first>
                        <option 
                          value 
                          disabled
                        >
                          -- Kies een relatie --
                        </option>
                      </template>
                    </b-select>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group>
                    <label for="ExternKenmerk">Externe referentie</label>
                    <b-form-input
                      id="ExternKenmerk"
                      v-model="factuur.Details.eigenschappen.ExterneReferentie"
                      type="text"
                      placeholder="De referentie / het werkopdrachtnummer van de klant."
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-group>
                    <label for="company">Onderwerp</label>
                    <b-form-input
                      id="company"
                      v-model="factuur.Onderwerp"
                      type="text"
                      placeholder="Het onderwerp op de factuur"
                    />
                  </b-form-group>
                  <b-form-group>
                    <div class="custom-control custom-checkbox">
                      <input
                        id="customChk4"
                        v-model="
                          factuur.Details.eigenschappen.OnderwerpBovenAdres
                        "
                        type="checkbox"
                        class="custom-control-input"
                      >
                      <label 
                        class="custom-control-label" 
                        for="customChk4"
                      >Onderwerp boven het adres vermelden</label>
                    </div>
                  </b-form-group>
                  <b-form-group>
                    <b-form-textarea
                      id="textarea2"
                      v-model="factuur.Details.eigenschappen.Omschrijving"
                      placeholder="Omschrijving van de factuur"
                      rows="3"
                      max-rows="6"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
            <b-col>
              <b-col v-if="factuur.Relatie">
                <b-form-group>
                  {{
                    factuur.Details.eigenschappen.OnderwerpBovenAdres
                      ? factuur.Onderwerp
                      : ""
                  }}
                  <div v-if="!hasCustomAdres">
                    {{ factuur.Relatie.Naam }}
                    <br>
                    {{ factuur.Relatie.Adres }}
                    <br>
                    {{ factuur.Relatie.Postcode }} {{ factuur.Relatie.Plaats }}
                    <br>
                    <br>
                  </div>
                </b-form-group>

                <b-form-group v-if="hasCustomAdres">
                  <b-form-textarea
                    id="textarea"
                    v-model="factuur.Details.adres"
                    placeholder="Adres"
                    rows="3"
                    max-rows="6"
                  />
                </b-form-group>

                <b-button-group v-if="hasCustomAdres">
                  <b-button 
                    small 
                    @click="presetBezoekAdres()"
                  >
                    Bezoekadres
                  </b-button>
                  <b-button 
                    small 
                    @click="presetPostAdres()"
                  >
                    Postadres
                  </b-button>
                </b-button-group>

                <div class="custom-control custom-checkbox">
                  <input
                    id="customChk3"
                    :checked="hasCustomAdres"
                    type="checkbox"
                    class="custom-control-input"
                    @click="factuur.Details.adres = hasCustomAdres ? null : ''"
                  >
                  <label 
                    class="custom-control-label" 
                    for="customChk3"
                  >Gebruik aangepast adres</label>
                </div>
              </b-col>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <b-form-group>
                <label for="company">Factuurdatum</label>
                <v-date-picker
                  v-if="factuur.Proforma"
                  v-model="factuur.Factuurdatum"
                  :min-date="new Date()"
                  mode="single"
                >
                  <b-input-group slot-scope="props">
                    <div class="input-group-prepend">
                      <span class="input-group-text">
                        <i class="fa fa-calendar" />
                      </span>
                    </div>

                    <b-form-input
                      :value="props.inputValue"
                      type="text"
                      placeholder="Datum van de factuur"
                      @change.native="props.updateValue($event.target.value)"
                    />
                  </b-input-group>
                </v-date-picker>
                <div v-else>
                  {{ factuur.Factuurdatum | formatDateTime("DD-MM-YYYY") }}
                </div>
              </b-form-group>

              <b-form-group v-if="factuur.Factuurdatum != null">
                <div class="custom-control custom-checkbox">
                  <input
                    id="customChk2"
                    v-model="factuur.Herhalen"
                    type="checkbox"
                    class="custom-control-input"
                  >
                  <label 
                    class="custom-control-label" 
                    for="customChk2"
                  >Jaarlijks herhalen (volgende factuur op
                    {{ volgendeDatum | formatDateTime("DD-MM-YYYY") }})</label>
                </div>
              </b-form-group>
            </b-col>
            <b-col 
              v-if="factuur.Proforma" 
              md="4"
            >
              <b-form-group :validated="factuur.AutomatischUitsturen">
                <label for="company">E-mailen naar</label>

                <b-input-group>
                  <b-input-group-prepend>
                    <b-dropdown 
                      text="Kies..." 
                      variant="primary"
                    >
                      <template slot="button-content">
                        <i class="fa fa-address-book" /> Kies...
                      </template>
                      <b-dropdown-item
                        v-for="(e, i) in emailadressen"
                        :key="i"
                        @click="factuur.VerzendenNaar = e.value"
                      >
                        {{ e.label }}
                        <br>
                        {{ e.value }}
                      </b-dropdown-item>
                    </b-dropdown>
                  </b-input-group-prepend>
                  <b-form-input
                    id="VerzendenNaar"
                    v-model="factuur.VerzendenNaar"
                    :required="factuur.AutomatischUitsturen"
                    type="email"
                    autocomplete="email"
                    placeholder="Naar welke e-mailadres moet de factuur verzonden worden?"
                  />
                  <b-input-group-append>
                    <b-input-group-text>
                      <i class="fa fa-envelope" />
                    </b-input-group-text>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
              <b-form-group v-if="factuur.Factuurdatum != null">
                <div class="custom-control custom-checkbox">
                  <input
                    id="customChk1"
                    v-model="factuur.AutomatischUitsturen"
                    type="checkbox"
                    class="custom-control-input"
                  >
                  <label 
                    class="custom-control-label" 
                    for="customChk1"
                  >Automatisch uitsturen
                    {{ directUitsturen ? "bij het opslaan" : "op " }}
                    {{
                      factuur.Factuurdatum | formatDateTime("DD-MM-YYYY")
                    }}</label>
                </div>
              </b-form-group>
            </b-col>
            <b-col 
              v-else 
              md="4"
            >
              <label for="company">Verstuurd naar</label>
              <div>{{ factuur.VerzendenNaar }}</div>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label for="company">Template</label>
                <b-form-select
                  v-model="factuur.TemplatePath"
                  :options="templates"
                />
              </b-form-group>
            </b-col>
          </b-row>

          <v-client-table
            id="dataTable"
            :columns="columns"
            :data="factuur.Factuurregels"
            :options="options"
            template="footerPagination"
            theme="bulma"
          >
            <div 
              slot="#" 
              slot-scope="props"
            >
              {{ props.index }}
            </div>

            <div 
              slot="Omschrijving" 
              slot-scope="props"
            >
              <b-input-group>
                <b-form-input
                  v-model="factuur.Factuurregels[props.index - 1].Omschrijving"
                  type="text"
                  placeholder="Omschrijving"
                />
                <b-input-group-append>
                  <b-button @click="factuur.Factuurregels[props.index - 1].Omschrijving = factuur.Details.eigenschappen.ExterneReferentie">
                    Externe referentie overnemen
                  </b-button>
                </b-input-group-append>
              </b-input-group>
              <br>
              <b-form-textarea
                id="textarea"
                v-model="
                  factuur.Factuurregels[props.index - 1].ExtraOmschrijving
                "
                placeholder="Extra omschrijving"
                rows="3"
                max-rows="6"
              />
            </div>

            <div 
              slot="Aantal" 
              slot-scope="props" 
              style="max-width: 120px"
            >
              <b-input-group>
                <b-input-group-addon>
                  <b-button
                    variant="primary"
                    @click="factuur.Factuurregels[props.index - 1].Aantal--"
                  >
                    -
                  </b-button>
                </b-input-group-addon>
                <b-form-input
                  id="elementsAppendButton"
                  v-model.number="props.row.Aantal"
                  type="text"
                />
                <b-input-group-append>
                  <b-button
                    variant="primary"
                    @click="factuur.Factuurregels[props.index - 1].Aantal++"
                  >
                    +
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </div>

            <div 
              slot="Bedrag" 
              slot-scope="props" 
              style="max-width: 100px"
            >
              <b-form-input
                v-model.number="factuur.Factuurregels[props.index - 1].Bedrag"
                type="number"
              />
            </div>

            <div 
              slot="Subtotaal" 
              slot-scope="props" 
              style="max-width: 100px"
            >
              {{ (props.row.Aantal * props.row.Bedrag) | formatNumber() }}
            </div>

            <a
              slot="Acties"
              slot-scope="props"
              href="#"
              class="btn btn-tertiary"
              variant="primary"
              @click="$delete(factuur.Factuurregels, props.index - 1)"
            >
              <i class="fa fa-trash" /> Delete
            </a>
          </v-client-table>

          <b-list-group flush>
            <b-list-group-item>
              <unit-modal
                v-if="factuur.Relatie"
                :relatie="factuur.Relatie"
                :regels="factuur.Factuurregels"
              >
                <b-button
                  variant="primary"
                  @click="
                    factuur.Factuurregels.push({
                      Aantal: 1,
                      Omschrijving: '',
                      ExtraOmschrijving: '',
                      Bedrag: 0,
                    })
                  "
                >
                  <i class="fa fa-plus" />
                  Factuurregel toevoegen
                </b-button>
                <b-button 
                  variant="warning" 
                  @click="setExtraOmschrijving()"
                >
                  <i class="fa fa-wizard" />
                  Pas alle extra omschrijvingen aan
                </b-button>
              </unit-modal>
              <b-alert 
                v-else 
                show 
                variant="info"
              >
                Om factuurregels toe te voegen dient eerst een relatie gekozen
                te worden.
              </b-alert>
            </b-list-group-item>
            <b-list-group-item>
              <div class="float-right">
                {{ factuurTotaal | formatNumber() }}
              </div>
            </b-list-group-item>
            <b-list-group-item>
              <b-row>
                <b-col>
                  <b-input-group>
                    <b-input-group-prepend>
                      <b-input-group-text>BTW</b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      v-model="
                        factuur.Details.eigenschappen.FactuurStandaardBTW
                      "
                      type="text"
                    />
                    <b-input-group-append>
                      <b-input-group-text>%</b-input-group-text>
                    </b-input-group-append>
                  </b-input-group>
                </b-col>
                <b-col>
                  <div
                    class="display-3 theme-color w-35 rounded mb-3 bg-gray-500 float-right"
                    style="color: white; text-align: right; padding: 10px"
                  >
                    {{ factuurTotaalInclBTW | formatNumber() }}
                  </div>
                </b-col>
              </b-row>
            </b-list-group-item>
            <b-list-group-item>
              <b-form-group>
                <label for="company">Betalingsvoorwaarden</label>
                <b-form-input
                  v-model="factuur.Details.eigenschappen.Betalingsvoorwaarden"
                  type="text"
                  placeholder="Geef hier een uitleg over de gehanteerde betalingsvoorwaarden."
                />
              </b-form-group>
            </b-list-group-item>

            <b-modal
              v-model="sendTest.showModal"
              title="Factuur versturen"
              class="modal-primary"
              cancel-title="Annuleren"
              ok-title="Versturen"
              ok-variant="primary"
              @ok="verstuurFactuurTest($props.id)"
              @cancel="sendTest.showModal = false"
            >
              <b-form-group>
                <label 
                  for="company"
                >Geef hieronder het e-mailadres op voor de test.</label>

                <b-input-group>
                  <div class="input-group-prepend">
                    <span class="input-group-text">
                      <i class="fa fa-envelope" />
                    </span>
                  </div>
                  <b-input v-model="sendTest.testEmail" />
                </b-input-group>
              </b-form-group>
              <b-alert 
                show 
                variant="danger"
              >
                Sla eerst de wijzingen op om deze terug te zien in de
                test(!)
              </b-alert>
            </b-modal>

            <b-list-group-item>
              <b-row>
                <b-col>
                  <b-form-group>
                    <label for="company">Bijlagen</label>
                    <upload-file
                      :folder="
                        'donkenliftadvies/' +
                          new Date().getUTCFullYear() +
                          '/factuurbijlagen'
                      "
                      cloud="tranpslan"
                      preset="hxdb54hj"
                      @file-uploaded="
                        factuur.Details.eigenschappen.Bijlagen.push($event)
                      "
                    />
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-list-group>
                    <b-list-group-item
                      v-for="(item, index) in factuur.Details.eigenschappen
                        .Bijlagen"
                      :key="item.public_id"
                    >
                      <div class="d-flex w-100 justify-content-between">
                        <h5 class="mb-1">
                          <i class="fa fa-paperclip" />
                          {{ item.original_filename }}.{{ item.format }}
                        </h5>
                        <small>
                          <b-button
                            class="btn btn-sm btn-danger"
                            @click="
                              factuur.Details.eigenschappen.Bijlagen.splice(
                                index,
                                1
                              )
                            "
                          >
                            <i class="fa fa-trash" />&nbsp;Verwijderen
                          </b-button>
                        </small>
                      </div>
                      <p class="mb-1">
                        {{ item.pages }}
                        {{ item.pages == 1 ? "pagina" : "pagina's" }}
                      </p>
                      <small>{{ formatBytes(item.bytes) }}</small>
                    </b-list-group-item>
                  </b-list-group>
                </b-col>
              </b-row>
            </b-list-group-item>
          </b-list-group>

          <div slot="footer">
            <b-button-toolbar class="float-right">
              <a
                href="#"
                class="btn btn-tertiary ml-1"
                onclick="javascript:window.print();"
              >
                <i class="fa fa-print" /> Print pagina
              </a>
              <b-button
                :disabled="!kanOpgeslagenWorden || isBusy"
                variant="success"
                class="mr-3"
                @click="
                  $props.id ? bijwerkenFactuur($props.id,false) : opslaanFactuur(false)
                "
              >
                <i 
                  v-if="!isBusy" 
                  class="fa fa-save mx-1"
                />
                <b-spinner
                  v-else
                  small
                />

                {{ $props.id ? "Wijziging opslaan" : "Aanmaken" }}
                {{
                  directUitsturen &&
                    factuur.AutomatischUitsturen &&
                    factuur.Proforma
                    ? " &amp; direct versturen"
                    : ""
                }}
              </b-button>

              <b-button
                :disabled="!kanOpgeslagenWorden || isBusy"
                variant="success"
                class="mr-3"
                @click="
                  $props.id ? bijwerkenFactuur($props.id,true) : opslaanFactuur(true)
                "
              >
                <i 
                  v-if="!isBusy" 
                  class="fa fa-save mx-1"
                />
                <b-spinner
                  v-else
                  small
                />

                {{ $props.id ? "Wijziging opslaan" : "Aanmaken" }} &amp; sluiten
                {{
                  directUitsturen &&
                    factuur.AutomatischUitsturen &&
                    factuur.Proforma
                    ? " &amp; direct versturen"
                    : ""
                }}
              </b-button>

              <b-button 
                class="mr-3" 
                variant="primary"
                @click="toonPreview($props.id)"
              >
                <font-awesome-icon icon="eye" /> Preview PDF
              </b-button>

              <b-modal 
                v-model="showPreview"
                ok-only
                ok-title="Sluiten"
                size="xl" 
                title="Voorbeeld factuur"
              >
                <pdf :src="factuurPreview" />
              </b-modal>
              <b-button
                :disabled="!$props.id"
                variant="danger"
                @click="verwijderenFactuur($props.id)"
              >
                <i class="fa fa-trash" /> Verwijderen
              </b-button>
            </b-button-toolbar>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Vue from "vue";
import { setupCalendar, DatePicker } from "v-calendar";
import "v-calendar/lib/v-calendar.min.css";
import vSelect from "vue-select";
import UnitModal from "@/components/UnitsModal";
import moment from "moment";
import VueNotifications from "vue-notifications";
import miniToastr from "mini-toastr"; // https://github.com/se-panfilov/mini-toastr
import UploadFile from "@/components/UploadFile";
import pdf from "vue-pdf";

const toastTypes = {
  success: "success",
  error: "error",
  info: "info",
  warn: "warn",
};

miniToastr.init({ types: toastTypes });

function toast({ title, message, type, timeout, cb }) {
  return miniToastr[type](message, title, timeout, cb);
}

const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast,
};
//  VueNotifications.setPluginOptions(options)

Vue.use(VueNotifications, options);

setupCalendar({
  firstDayOfWeek: 2, // Monday
});

export default {
  name: "ConceptInvoice",
  components: {
    pdf,
    "upload-file": UploadFile,
    "unit-modal": UnitModal,
    "v-date-picker": DatePicker,
    vSelect,
  },
  mixins: [],
  props: {
    id: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      factuurPreview: null,
      showPreview: false,
      isBusy: false,
      relaties: [],
      wizard: false,
      templates: [],
      units: [],
      sendTest: {
        testEmail: "",
        showModal: false,
      },
      werkzaamheden: ["Beheer", "Advies", "Inspectie", "Overig"],
      columns: ["#", "Omschrijving", "Aantal", "Bedrag", "Subtotaal", "Acties"],
      options: {
        headings: {},
        sortable: [],
        filterable: false,
        highlightMatches: true,
        texts: {
          noResults: "Geen factuurregels",
          count:
            "{from} - {to} van {count} regels|{count} regels|{count} regel",
          first: "Eerste pagina",
          last: "Laatste pagina",
          filter: "Zoeken:",
          filterPlaceholder: "zoekterm",
          limit: "Factuurregels:",
          page: "Pagina:",
        },
        sortIcon: {
          base: "fa",
          up: "fa-sort-asc",
          down: "fa-sort-desc",
          is: "fa-sort",
        },
        pagination: {
          chunk: 5,
          edge: false,
          nav: "scroll",
        },
      },
      factuur: {
        Factuurnummer: null,
        Details: {
          eigenschappen: {
            ExterneReferentie: null,
            FactuurStandaardBTW: 21.0,
            Betalingsvoorwaarden: "Betaling binnen 30 dagen.",
            Omschrijving: "Hierbij onze factuur:",
            OnderwerpBovenAdres: false,
            Bijlagen: [],
          },
          adres: null,
        },
        Factuurdatum: null,
        TemplatePath: "preset 1 (standaard)",
        Onderwerp: "",
        Proforma: true, // standaard is een factuur proforma
        Prijspeiljaar: new Date().getUTCFullYear(),
        VerzendenNaar: "",
        AutomatischUitsturen: false,
        Herhalen: false,
        Factuurregels: [],
      },
    };
  },
  notifications: {
    showSuccessMsg: {
      type: VueNotifications.types.success,
      title: "Gelukt!",
      message: "That's the success!",
    },
    showInfoMsg: {
      type: VueNotifications.types.info,
      title: "Info",
      message: "Here is some info for you",
    },
    showWarnMsg: {
      type: VueNotifications.types.warn,
      title: "Let op!",
      message: "That's the kind of warning",
    },
    showErrorMsg: {
      type: VueNotifications.types.error,
      title: "Ach nee hè? :/",
      message: "Er ging iets mis...",
    },
  },
  computed: {
    emailadressen: function () {
      var e = [];
      if (this.factuur.Relatie) {
        e.push({ label: "Algemeen", value: this.factuur.Relatie.Email });
        e.push({ label: "Financieel", value: this.factuur.Relatie.FinEmail });
        for (var key in this.factuur.Relatie.Config.emailadressen) {
          var email = this.factuur.Relatie.Config.emailadressen[key];
          e.push({ label: email.type.omschrijving, value: email.adres });
        }
      }
      return e;
    },
    hasCustomAdres: function () {
      return this.factuur.Details.adres != null; 
    },
    factuurTotaal: function () {
      var totaal = 0.0;
      if (this.factuur.Factuurregels) {
        this.factuur.Factuurregels.forEach((elem) => {
          totaal += elem.Aantal * elem.Bedrag;
        });
      }

      return totaal;
    },
    factuurTotaalInclBTW() {
      return (
        Number(this.factuurTotaal) *
        ((100 +
          Number(this.factuur.Details.eigenschappen.FactuurStandaardBTW)) /
          100)
      );
    },
    volgendeDatum: function () {
      var d = this.factuur.Factuurdatum;
      if (d instanceof Date && !isNaN(d.valueOf()))
        return new Date(d.getFullYear() + 1, d.getMonth(), d.getDate());
      return new Date();
    },
    isUitgestuurd: function () {
      return this.factuur.Factuurnummer != null;
    },
    directUitsturen: function () {
      return this.factuur.Factuurdatum < new Date();
    },
    kanOpgeslagenWorden: function () {
      var f = this.factuur;
      return (
        (f.Factuurdatum != null && f.VerzendenNaar.length != 0) ||
        !f.AutomatischUitsturen
      );
    },
  },
  watch: {
    wizard: function (val) {
      console.log(val);
      this.getUnits();
    },
    
  },
  mounted() {
    this.getRelaties(this.$props.id);
  },
  methods: {
    toonPreview(id) {
      this.factuurPreview = null
      var vm = this
      this.$http.get( `/facturen/factuur/${id}/preview`)
        .then((response) => {
          //console.log(response.data.pdf)
          vm.factuurPreview = response.data.pdf 
          vm.showPreview = true
        })
    },
    checkFacturatieAdres(relatie) {
      var adres = relatie.Config.facturatieadres;
      var hasAdres = adres != undefined && adres.length > 0
      if (this.factuur.Details.adres == null && hasAdres) this.factuur.Details.adres = adres
    },
    showSendModal() {
      this.sendTest.testEmail = this.$store.state.user.username;
      this.sendTest.showModal = true;
    },
    setExtraOmschrijving(tekst = prompt("Vul een nieuwe omschrijving in")) {
      if (this.factuur.Factuurregels) {
        this.factuur.Factuurregels.forEach((elem) => {
          elem.ExtraOmschrijving = tekst;
        });
      }
    },
    maakKopieFactuur() {
      this.factuur.id = null;
      this.factuur.Factuurnummer = null;
      this.factuur.Proforma = true;
      this.$router.push({ name: "FactuurNieuw" });
    },
    presetBezoekAdres() {
      var r = this.factuur.Relatie;
      this.factuur.Details.adres =
        r.Naam + "\n" + r.Adres + "\n" + r.Postcode + " " + r.Plaats;
    },
    presetPostAdres() {
      var r = this.factuur.Relatie;
      this.factuur.Details.adres =
        r.Naam +
        "\nPostbus " +
        r.Postbus +
        "\n" +
        r.PostbusCode +
        " " +
        r.Plaats;
    },
    formatBytes(bytes, decimals = 2) {
      if (bytes === 0) return "0 Bytes";

      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

      const i = Math.floor(Math.log(bytes) / Math.log(k));

      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
    },
    processResponse(f) {
      f.Factuurdatum = moment(f.Factuurdatum).isValid()
        ? moment(f.Factuurdatum).toDate()
        : null;
      return f;
    },
    verwijderenFactuur(id) {
      var vm = this;
      vm.isBusy = true;
      this.$http
        .delete("/facturen/factuur/" + id)
        .then(function (response) {
          console.log(response);
          vm.$router.push({ name: "Facturatie" });
          vm.showInfoMsg({ message: "Factuur is verwijderd." });
        })
        .catch(function (error) {
          console.log(error);
        })
        .then(function () {
          vm.isBusy = false;
        });
    },
    opslaanFactuur: function (redirect) {
      var vm = this;
      vm.isBusy = true;
      this.$http
        .post(
          "/facturen/" + this.factuur.Prijspeiljaar,
          {
            factuur: this.factuur,
          },
          
        )
        .then(function (response) {
          console.log(response.data);
          if (response.data.resultaat.RemoteId) {
            vm.$router.push(
              "/facturatie/factuur/" + response.data.resultaat.RemoteId
            );
            vm.showSuccessMsg({ message: "De nieuwe factuur is aangemaakt." });
            vm.getFactuur(response.data.resultaat.RemoteId);
            if (redirect)  vm.$router.push({ name: "Facturatie" });
          } else {
            vm.showErrorMsg({
              message: "Er is iets misgegaan bij het aanmaken!",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
        })
        .then(function () {
          vm.isBusy = false;
        });
    },

    getRelaties: function (factuurId) {
      var vm = this;
      this.$http
        .get("/relaties")
        .then(function (response) {
          console.log(response.data);
          vm.relaties = response.data.relaties;
          vm.templates = response.data.presets;

          if (factuurId) vm.getFactuur(factuurId);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getFactuur: function (id) {
      var vm = this;

      this.$http
        .get("/facturen/factuur/" + id)
        .then(function (response) {
          console.log(response.data);
          vm.factuur = vm.processResponse(response.data.factuur);
          vm.templates = response.data.templates;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    bijwerkenFactuur: function (id,redirect) {
      var vm = this;
      vm.isBusy = true;
      this.$http
        .put(
          "/facturen/factuur/" + id,
          {
            factuur: this.factuur,
          },
          
        )
        .then(function (response) {
          console.log(response.data.factuur);
          vm.factuur = vm.processResponse(response.data.factuur);
          vm.showSuccessMsg({ message: "Factuur bijgewerkt!" });
          if (redirect)  vm.$router.push({ name: "Facturatie" });
        })
        .catch(function (error) {
          console.log(error);
          vm.showErrorMsg({
            message: error.response.data.error,
          });
        })
        .then(function () {
          vm.isBusy = false;
        });
    },
    verstuurFactuurTest: function (id) {
      console.log("Verstuur factuur...");
      var vm = this;
      this.$http
        .post(
          "/facturen/factuur/" + id + "/verzenden/test",
          {
            email: this.sendTest.testEmail,
          },
          
        )
        .then(function (response) {
          console.log(response.data);
          vm.sendTest.showModal = false;
          //vm.factuur = vm.processResponse(response.data.factuur);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getUnits: function () {
      var vm = this;
      this.$http
        .get("/relaties/" + this.factuur.Relatie.Id + "/units")
        .then(function (response) {
          vm.units = response.data.units;
        })
        .catch(function (error) {
          console.log(error);
        })
        .then(function () {
          // always executed
        });
    },
  },
};
</script>
<style lang="scss">
#dataTable {
  width: 100%;
  margin: 0 auto;

  .VuePagination {
    text-align: center;
    justify-content: center;
  }

  .vue-title {
    text-align: center;
    margin-bottom: 10px;
  }

  .VueTables__search-field {
    display: flex;
  }
  .VueTables__search-field input {
    margin-left: 0.25rem;
  }

  .VueTables__limit-field {
    display: flex;
  }

  .VueTables__limit-field select {
    margin-left: 0.25rem !important;
  }

  .VueTables__table th {
    text-align: left;
  }

  .VueTables__child-row-toggler {
    width: 16px;
    height: 16px;
    line-height: 16px;
    display: block;
    margin: auto;
    text-align: center;
  }

  .VueTables__child-row-toggler--closed::before {
    content: "+";
  }

  .VueTables__child-row-toggler--open::before {
    content: "-";
  }
}
</style>